import Vue from 'vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
// 寮曞叆鍏ㄥ眬css
import './assets/scss/style.scss';
// 鎸夐渶寮曞叆vue-awesome鍥炬爣
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
// 鎸夐渶寮曞叆--
// import { Button, Select } from 'element-ui';
/* 鎴栧啓涓? * Vue.use(Button)
 * Vue.use(Select)
 */
/**
 * 
 * 鎴栬€呯洿鎺ユ敞鍐? */
// Vue.component(Button.name, Button);
// Vue.component(Select.name, Select);

//寮曞叆echart
//4.x 寮曠敤鏂瑰紡
import echarts from 'echarts'
//5.x 寮曠敤鏂瑰紡涓烘寜闇€寮曠敤
//甯屾湜浣跨敤5.x鐗堟湰鐨勮瘽,闇€瑕佸湪package.json涓洿鏂扮増鏈彿,骞跺垏鎹㈠紩鐢ㄦ柟寮?//import * as echarts from 'echarts'

// 寮曞叆鍦板浘鏁版嵁
import chinaJson from './common/map/china.json'
import hfJson from './common/map/hf.json'
import hnJson from './common/map/hn.json'
import gdJson from './common/map/gd.json'

// 娉ㄥ唽鍦板浘
echarts.registerMap('china', chinaJson);
echarts.registerMap('hf', hfJson);
echarts.registerMap('hn', hnJson);
echarts.registerMap('gd', gdJson);

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

Vue.prototype.$screenWidth = window.innerWidth

// 延迟执行函数，控制触发频率
function delay(fn, delay) {
  let timeout = null;
  return function () {
      // 清除上一次定时器
      if (timeout) {
          clearTimeout(timeout);
      }
      // 设置新的定时器
      timeout = setTimeout(() => {
          fn.apply(this, arguments);
      }, delay);
  }
}

// function resize() {
//   console.log('resize executed');
//   window.location.reload()
// }
// window.onresize = delay(resize, 300);


// 鍏ㄥ眬娉ㄥ唽
Vue.component('icon', Icon);
Vue.use(dataV);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

